
import React from 'react';
import $ from 'zzc-zepto';
import propTypes from 'prop-types';
import classNames from 'classnames';

import './style.css';

import {connect} from 'react-redux';
import * as tripAction from '../../store/actions/trip';
import { sendStatsEvent } from '../statistics';

class TripDaysTabbar extends React.Component{
  render(){
    let {days, current, selectDay} = this.props;

    let listView = [];
    for (let day = 0; day <= days; day++) {
      listView.push(
        <Item
          key={day + ''}
          day={day}
          active={day === current}
          onChange={selectDay} />
      );
    }

    return (
      <div className="trip-day-tabbar-wrap">
        <div className='trip-day-tabbar' ref={(node) => this.node = node}>
          <ul>{listView}</ul>
        </div>
      </div>
    );
  }
  
  componentDidMount(){
    this.scrollToActive();
  }

  componentDidUpdate(preProps) {
    let props = this.props;

    if (preProps.current !== props.current) {
      this.scrollToActive();
    }
  }

  scrollToActive() {
    if (!this.node) return;

    let $scrollEl = $(this.node);
    let $activeEl = $scrollEl.find('.active');

    if (!$activeEl.length) return;

    let left = $activeEl.position().left;
    left = left - $scrollEl.width() / 2 + $activeEl.width() / 2;
    
    $scrollEl.scrollLeft(left);
  }

  
}


TripDaysTabbar.propTypes = {
  days: propTypes.number.isRequired,
  current: propTypes.number.isRequired
};



Item.propTypes = {
  day: propTypes.number.isRequired,
  active: propTypes.bool.isRequired,
  onChange: propTypes.func.isRequired
};

function Item(props) {
  let {day, active, onChange} = props;
  let text = day > 0 ? `第${day}天` : '全程';
  let cls = classNames('item', {active: active});

  return (
    <li className={cls}>
      <button onClick={() => {
        sendStatsEvent('trip_dayswitch_click');
        onChange(day);
      }}>{text}</button>
    </li>
  );
}


export default connect(function (state, ownProps) {
  return ownProps;
}, tripAction)(TripDaysTabbar);



// WEBPACK FOOTER //
// ./src/components/TripDayTabbar/index.js